// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"cL-z","carouselContainer":"dL-z"};